import { IBaseAction } from '@models/actions/IBaseAction';
import { IBackgroundJobStarted } from '@models/backgroundJobs/IBackgroundJob';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import { FilesService } from '@services/FilesService';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { BackgroundJobTask } from '@services/backgroundJobs/backgroundJobTask';
import AttachmentsArchiveModal from '@molecules/AttachmentsArchiveWait/AttachmentsArchiveModal';
import { createAttachmentsArchiveTask } from '@molecules/AttachmentsArchiveWait/attachmentsArchiveTask';

/**
 * Кнопка документа, которая скачивает архив вложений (GET `documentExecution/<syncRoute>/{docId}/{actionKey}`). С
 * ClientOptions `runInBackground` архив собирает фоновая задача, а ход и итог показывает окно; без флага — файл сразу.
 */
export abstract class AttachmentsArchiveExecutor extends DocBaseActionExecutor {
    private _archive?: { header: string; task: BackgroundJobTask; close: () => void };

    protected abstract readonly syncRoute: string;

    protected abstract startInBackground(
        service: DocumentExecutionService,
        actionKey: string,
    ): Promise<IBackgroundJobStarted>;

    runInternal = (
        objId: string,
        _parentId: string | undefined,
        action: IBaseAction,
        _rowData?: unknown,
        completeHandler?: (isSucceed: boolean) => void,
    ) => {
        const syncUrl = `documentExecution/${this.syncRoute}/${objId}/${action.key}`;
        if (!action.options?.runInBackground) {
            FilesService.downloadFileNative(syncUrl);
            completeHandler && completeHandler(false);
            return;
        }

        const close = () => completeHandler && completeHandler(false);
        const service = new DocumentExecutionService(objId);
        this._archive = {
            header: action.displayName,
            close,
            task: createAttachmentsArchiveTask(() => this.startInBackground(service, action.key), {
                syncUrl,
                onSyncDownload: close,
            }),
        };
    };

    visualElementInner = () =>
        this._archive ? (
            <AttachmentsArchiveModal
                header={this._archive.header}
                task={this._archive.task}
                onClose={this._archive.close}
            />
        ) : (
            <></>
        );
}
